
import {  defineComponent, inject, ref, computed, onMounted, onBeforeMount, onUpdated, watch } from 'vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import ForgotPassword from './ForgotPassword.vue'
import DobleFactor from './DobleFactor.vue'
import { Container } from 'inversify'
import loginComp from './Login'
import { useStore } from 'vuex'
import ConfigurationConst from '../../../../../common/domain/constantes/ConfigurationConst'
import IliniumColorsConst from '../../../../../common/domain/constantes/Colors/IliniumColorsConst'
import AunnaColorsConst from '../../../../../common/domain/constantes/Colors/AunnaColorsConst'
import AllianceColorsConst from '../../../../../common/domain/constantes/Colors/AllianceColorsConst'
import WillisColorsConst from '../../../../../common/domain/constantes/Colors/WillisColorsConst'
import IntrasoftColorsConst from '../../../../../common/domain/constantes/Colors/IntrasoftColorsConst'
import PerisColorsConst from '../../../../../common/domain/constantes/Colors/PerisColorsConst'
import AunnaApplicationConst from '../../../../../common/domain/constantes/Applications/AunnaApplicationConst'
import AllianceApplicationConst from '../../../../../common/domain/constantes/Applications/AllianceApplicationConst'
import IliniumApplicationConst from '../../../../../common/domain/constantes/Applications/IliniumApplicationConst'
import IntrasoftApplicationConst from '../../../../../common/domain/constantes/Applications/IntrasoftApplicationConst'
import PerisApplicationConst from '../../../../../common/domain/constantes/Applications/PerisApplicationConst'
import WillisApplicationConst from '../../../../../common/domain/constantes/Applications/WillisApplicationConst'
import Environment from '../../../../../common/domain/constantes/environment'
import { isRef, RefSymbol, toRef } from '@vue/reactivity'
import { appConfig } from '../../domain/appConfig'
import { codeFolding } from '@codemirror/language'
import { logMissingFieldErrors } from '@apollo/client/core/ObservableQuery'

const __default__ = defineComponent({
    components: { ForgotPassword, DobleFactor,InputText, Button, Toast },
    name: 'login1',
    props: {
        routes: Object,
        container: {
            type: Object as () => Container            
        }, 
      
    },
    setup(props) {

        const ipublicPath = inject('publicPath', () => { })

        let showModalAuthType = ref(false);
        const store = useStore();
        //let color1 = Environment.APPAPPCOLOR1
        //let color2 = Environment.APPAPPCOLOR2

        const {
            request,
            onSubmitLogin,
            onSubmitForgotPassword,
            submitButton,
            bodyLogin,
            carousel,
            pageLoad,
            isForgetPass,
            emailControl,
            pwdControl,
            showLoading,
            isLoading,
            v$,
            isValidLoginData,
            submitted,
            handleSubmit,
            version,
            getLogoPanelUrl,
            getLogoUrl,
            getFaviconUrl,
            getVersion,                        
            appCfg,
            appCatalog,
        } = loginComp(ipublicPath as any, props.routes, props.container as any, showModalAuthType,props,store)
       
        let color1 = computed(() => appCfg.color1);
        let color2 = computed(() => appCfg.color2);

        const getFaviconBase64 = (): string => {
            const ficon = computed<string>(() => appCfg.favicon);
            const href:string = "data:image/ico;base64," + ficon.value;
            return href;
        }

        //let favicon:string = "data:image/png;base64,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";
        //let favicon:string = getFaviconBase64();
        let favicon:string = getFaviconUrl.value;

        onMounted(() => {
            //changeFavicon(favicon)
            //changeThemeCss();
        });

        onUpdated(() => {
            
        });

        const changeFavicon = (favicon:string): boolean => {
            var link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel','icon');
                document.head.appendChild(link);
            }
            link.setAttribute('href', favicon);
            return true;
        }
      
        watch(appCatalog, (value: any) => {
            //changeThemeCss();
            //changeLayoutCss();
        });

        const changeThemeCss = (): boolean => {
            var link = document.querySelector("link[id~='theme-css']");
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('id','theme-css');
                link.setAttribute('rel','stylesheet');
                link.setAttribute('type', 'text/css')
                document.head.appendChild(link);
            }
            const appPublic = process.env.VUE_APP_PUBLIC_PATH ?? '/';
            let template = appCatalog.value.find(x => x.typeId == 'templarend')?.value!;
            let theme = appCatalog.value.find(x => x.typeId == 'templatetheme')?.value!;
            let style = appCatalog.value.find(x => x.typeId == 'templatethemestyle')?.value!;
            let href = `${appPublic}${template}/${theme}/${style}`            
            link.setAttribute('href', href);
            return true;
        }

        const changeLayoutCss = (): boolean => {
            var link = document.querySelector("link[id~='layout-css']");
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('id','layout-css');
                link.setAttribute('rel','stylesheet');
                link.setAttribute('type', 'text/css')
                document.head.appendChild(link);
            }
            const appPublic = process.env.VUE_APP_PUBLIC_PATH ?? '/';
            let layout = appCatalog.value.find(x => x.typeId == 'templarend')?.additionalValue!;
            let href = `${appPublic}${layout}`  
            link.setAttribute('href', href);
            return true;
        }

        return {
            request,
            onSubmitLogin,
            onSubmitForgotPassword,
            submitButton,
            bodyLogin,
            carousel,
            pageLoad,
            isForgetPass,
            emailControl,
            pwdControl,
            showLoading,
            isLoading,
            ipublicPath,
            v$,
            isValidLoginData,
            submitted,
            handleSubmit,
            version,
            getLogoPanelUrl,
            getLogoUrl,
            getFaviconUrl,
            getVersion,                        
            showModalAuthType,
            color1,
            color2,
            appCfg,
            getFaviconBase64,
            favicon
        };
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "45db1e20-color1": (_ctx.color1),
  "45db1e20-color2": (_ctx.color2)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__